export const ORGANIZATION_CONFIG_SET = 'ORGANIZATION_CONFIG_SET';
